import { render, staticRenderFns } from "./awardsDetail.vue?vue&type=template&id=4061c738&scoped=true"
import script from "./awardsDetail.vue?vue&type=script&lang=js"
export * from "./awardsDetail.vue?vue&type=script&lang=js"
import style0 from "./awardsDetail.vue?vue&type=style&index=0&id=4061c738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061c738",
  null
  
)

export default component.exports